export function getOptimalSourceObject(sources, componentWidth) {
  if (!sources?.length) {
    return null;
  }

  const targetWidth = componentWidth || 760;
  const sorted = [...sources]
    .filter((source) => source?.source_url)
    .sort((a, b) => (a.width || 0) - (b.width || 0));

  if (!sorted.length) {
    return null;
  }

  let bestSource = sorted.find((source) => source.width >= targetWidth);
  if (!bestSource) {
    bestSource = sorted[sorted.length - 1];
  }

  return bestSource;
}

export function getOptimalSource(sources, componentWidth) {
  return getOptimalSourceObject(sources, componentWidth)?.source_url || null;
}

export function buildImageSrcSet(sources) {
  if (!sources?.length) {
    return undefined;
  }

  const srcSet = [...sources]
    .filter((source) => source?.source_url && source?.width)
    .sort((a, b) => a.width - b.width)
    .map((source) => `${source.source_url} ${source.width}w`)
    .join(', ');

  return srcSet || undefined;
}

export function findMediaSources(media, mediaType) {
  if (!media) return null;
  const found = media.find((i) => i.type === mediaType && i.sources.length > 0);
  return found?.sources || [];
}

export function findImageSources(media) {
  return findMediaSources(media, 'image');
}
